// The turns still streaming and the sessions still loading, per customer, so
// clearing the session or unloading the customer can stop them: a turn that
// kept streaming would write itself back into a store that was just emptied,
// and keep the model running; a load would bring back the session just cleared.
const controllersByCustomerId = new Map();

export function startRequest(customerId) {
  const controller = new AbortController();
  if (!controllersByCustomerId.has(customerId)) {
    controllersByCustomerId.set(customerId, new Set());
  }
  controllersByCustomerId.get(customerId).add(controller);
  return controller;
}

export function finishRequest(customerId, controller) {
  const controllers = controllersByCustomerId.get(customerId);
  if (!controllers) {
    return;
  }
  controllers.delete(controller);
  if (controllers.size === 0) {
    controllersByCustomerId.delete(customerId);
  }
}

// Clears whose DELETE hasn't answered, per customer. Until it does, glados still
// has the old session active: an ask would join it, and a load would bring its
// turns back.
const pendingClearsByCustomerId = new Map();

export function startClear(customerId) {
  pendingClearsByCustomerId.set(customerId, (pendingClearsByCustomerId.get(customerId) || 0) + 1);
}

export function finishClear(customerId) {
  const pending = (pendingClearsByCustomerId.get(customerId) || 0) - 1;
  if (pending > 0) {
    pendingClearsByCustomerId.set(customerId, pending);
  } else {
    pendingClearsByCustomerId.delete(customerId);
  }
}

export function isClearing(customerId) {
  return pendingClearsByCustomerId.has(customerId);
}

export function abortRequests(customerId) {
  const controllers = controllersByCustomerId.get(customerId);
  if (!controllers) {
    return;
  }
  controllersByCustomerId.delete(customerId);
  controllers.forEach(controller => controller.abort());
}
